export type ShopifyBillingSource = 'shopify' | 'direct';

export type ShopifyInstallGoal =
  | 'grow_list'
  | 'newsletters'
  | 'automations'
  | 'browse';

export type ShopifyPreviousTool =
  | 'none'
  | 'mailchimp'
  | 'klaviyo'
  | 'omnisend'
  | 'shopify_email'
  | 'other';

export type ShopifyRevenueBand =
  | '0-100k'
  | '100k-250k'
  | '250k-1m'
  | '1m-5m'
  | '5m-25m'
  | '25m+';

export const SHOPIFY_INSTALL_STEP_PATHS = [
  'account',
  'workspace',
  'goals',
  'current-tool',
  'industry',
  'revenue',
  'contacts',
  'attribution',
  'billing',
  'sync',
] as const;

export type ShopifyInstallStepPath = (typeof SHOPIFY_INSTALL_STEP_PATHS)[number];

export interface ShopifyInstallWizardState {
  shopDomain: string;
  host?: string;
  workspaceId?: string;
  /** Skip account creation when merchant logged into existing account */
  isExistingUser?: boolean;
  businessName?: string;
  contactEmail?: string;
  phone?: string;
  firstName?: string;
  lastName?: string;
  goal?: ShopifyInstallGoal;
  previousTool?: ShopifyPreviousTool;
  industry?: string;
  revenueBand?: ShopifyRevenueBand;
  subscriberCount?: number;
  referralChannel?: string;
  billingPlan?: 'starter' | 'pro' | 'business';
  completedSteps?: ShopifyInstallStepPath[];
}
